module.exports = __webpack_public_path__ + "img/S10.dbb0a001.svg";